import styled from 'styled-components';
import theme from '../../../../constants/theme';

export const FeedSC = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;

  .feed-card {
    position: relative;
    background: #fff;
    /* border: 1px solid #d9dae3; */
    border-radius: 8px;
    margin-bottom: 24px;
    box-shadow: ${({ theme }) => theme.shadows.low};
  }

  .feed-card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: -66px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #d7d9e2;
  }

  .feed-dots {
    position: absolute;
    top: 57px;
    left: -40px;
    border-left: 2px dotted #d7d9e2;
    height: calc(100% - 40px);
  }
`;

export const FeedPatientsSC = styled.div`
  .body {
    padding: 24px;
  }

  .body-empty {
    padding: 84px 24px;
    text-align: center;

    p {
      font-weight: 600;
      margin: 8px 0 24px;
    }
  }

  .body-empty-content {
    max-width: 278px;
    margin: 0 auto;
  }
`;

export const FeedNoReceiptsSC = styled.div`
  .fnr-body {
    display: flex;
    height: 268px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    h3 {
      line-height: 1.5;
      color: #a3a5ae;
      font-weight: 800;
      font-size: 20px;
      margin-bottom: 16px;
    }

    p {
      max-width: 260px;
      font-weight: 600;
    }

    .icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: linear-gradient(
        180deg,
        rgba(163, 165, 174, 0) 0%,
        rgba(163, 165, 174, 0) 20%,
        rgba(163, 165, 174, 0.05) 70%,
        rgba(163, 165, 174, 0.2) 100%
      );
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

type TFeedAlertSC = {
  alertType?: 'ERROR' | 'SUCCESS';
};
export const FeedAlertSC = styled.div<TFeedAlertSC>`
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 4px;
  text-align: center;
  border: 1px solid ${theme.colors.success};
  color: ${theme.colors.success};
  background: #f3fdf7;

  ${({ alertType }) =>
    alertType === 'ERROR'
      ? `
  color: ${theme.colors.error};
  border-color: ${theme.colors.error};
  background: #ffeef2;
  `
      : ''}
  p {
    line-height: 20px;
    margin-bottom: 0;
    font-weight: 600;
  }

  .fa-title {
    font-size: 16px;
  }

  .fa-message {
    font-size: 14px;
  }
`;

export const FeedCardHeaderSC = styled.header`
  width: 100%;
  padding: 24px 24px 12px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .content {
    flex: 1;
  }

  .navigation {
    margin-left: 32px;
    margin-top: -5px;
  }

  border: none;
  border-bottom: 1px solid #d7d9e2;
  background: none;
  outline: none;

  .fch-label {
    line-height: 1.4;
    font-size: 14px;
    color: rgba(24, 30, 52, 0.6);
    margin-bottom: 8px;
    font-weight: 600;
    text-align: left;
  }

  .fch-time {
    font-weight: lighter;
    color: #141b38;
    font-size: 24px;
    line-height: 1.3;
    text-transform: capitalize;
  }
`;

export const FeedReceiptsSC = styled.div`
  padding: 24px;
`;

export const FeedEVisitsSC = styled.div`
  box-shadow: ${({ theme }) => theme.shadows.low};

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .stats {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 16px;

      .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 4px;
      }

      .indicator {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin-right: 8px;

        &.free {
          background: #62ab81;
        }

        &.premium {
          background: #ff4496;
        }

        &.not-booked {
          background: #f5f5f7;
          border: 1px solid #d7d9e2;
        }
      }
    }
  }

  .items {
    padding: 24px;

    .empty {
      height: 212px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      h3 {
        line-height: 1.5;
        color: #a3a5ae;
        font-weight: 800;
        font-size: 20px;
        margin-bottom: 16px;
      }

      p {
        font-weight: 600;
      }

      .icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: linear-gradient(
          180deg,
          rgba(163, 165, 174, 0) 0%,
          rgba(163, 165, 174, 0) 20%,
          rgba(163, 165, 174, 0.05) 70%,
          rgba(163, 165, 174, 0.2) 100%
        );
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;
